import { FIND_USER } from "../../routes";
import customAxios from "../../customAxios";
import { IFindUserInformation } from "../../../types/common.interface";
import utils from "../../../utils";

interface iQuery {
  value: string | undefined;
  target: "province" | "_id";
}

async function getAllGovernmentShip(props: IFindUserInformation) {
  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                               Value Validations
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------
  var thisUrl = FIND_USER + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;
  const populateFields =
    "userTypes avatar balance blocks balance governmentShipInformation.province governmentShipInformation.name";
  thisUrl += `&populate=${populateFields}`;

  let body: any = {
    query: {
      userTypes: {
        $in: ["GOVERNMENTSHIP"],
      },
    },
  };

  // ** ---------------------------------------------------------------------------------------------------------------------
  // ** =====================================================================================================================
  // **                                                      Local Functions
  // ** =====================================================================================================================
  // ** ---------------------------------------------------------------------------------------------------------------------

  function query({ value, target }: iQuery) {
    body = {
      query: {
        ...body.query,
        "provinceEducationInformation.province":
          target === "province" ? value : undefined,

        _id: target === "_id" ? value : undefined,
      },
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                            Searching For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.search?.value) {
    body = {
      query: {
        ...body.query,
        [String(props.search.base)]: utils.convertNumbers2English(
          props.search.value
        ),
      },
    };
  }

  // ?? ---------------------------------------------------------------------------------------------------------------------
  // ?? =====================================================================================================================
  // ??                                                    Filtering For SuperAgent
  // ?? =====================================================================================================================
  // ?? ---------------------------------------------------------------------------------------------------------------------

  if (props?.filters) {
    const { province, _id } = props.filters;
    if (province) query({ target: "province", value: province?._id });
    if (_id) query({ target: "_id", value: _id });
  }

  // !! ---------------------------------------------------------------------------------------------------------------------
  // !! =====================================================================================================================
  // !!                                            Try Catch For SuperAgent
  // !! =====================================================================================================================
  // !! ---------------------------------------------------------------------------------------------------------------------
  try {
    return (await customAxios.post(thisUrl, body)).data;
  } catch (error: any) {
    console.log({ GET_ALL_SUPER_AGENT: error });
  }
}

export default getAllGovernmentShip;
